module.exports = __webpack_public_path__ + "img/about_logo_24.3cbdfcb6.png";